var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9671 3.96892C12.9971 2.65802 14.8983 2.43833 16.2001 3.47978L18.0765 4.9809C19.3623 6.00952 19.5787 7.88223 18.5614 9.17697L9.08654 21.2359C8.70737 21.7185 8.12763 22.0003 7.51391 22.0003H3.21917L2.1486 17.718C1.99871 17.1184 2.13442 16.4832 2.51625 15.9973L11.9671 3.96892ZM14.9507 5.04152C14.5168 4.69437 13.8831 4.7676 13.5397 5.20457L12.532 6.48711L16.0655 9.11647L16.9888 7.94133C17.3279 7.50975 17.2557 6.88551 16.8272 6.54264L14.9507 5.04152ZM14.8294 10.6896L11.296 8.06029L4.08889 17.2329L4.78072 20.0003H7.51391L14.8294 10.6896ZM12.4999 21.0003C12.4999 20.448 12.9477 20.0003 13.4999 20.0003H20.4999C21.0522 20.0003 21.4999 20.448 21.4999 21.0003C21.4999 21.5525 21.0522 22.0003 20.4999 22.0003H13.4999C12.9477 22.0003 12.4999 21.5525 12.4999 21.0003Z",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditBlack);
export default __webpack_public_path__ + "static/media/edit_black.694bac1d1467a045801fdd2e4df407d6.svg";
export { ForwardRef as ReactComponent };